export enum TranslationStatusEnum {
  ItemDoesNotExist = "Item to translate doesn't exist",
}
